import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabButton } from './tab-button.interface';

@Component({
  selector: 'usb-tab-buttons',
  templateUrl: './tab-buttons.component.html',
  styleUrls: ['./tab-buttons.component.scss']
})
export class TabButtonsComponent implements OnInit {
  @Input() categoryId: number = 0;
  @Input() activeTab: string = '';
  @Input() quote: boolean = true;
  @Input() buttonColorActive: string = '#e93a5b';
  @Input() buttonTextActive: string = '#333';
  @Input() productSelect: boolean = true;
  @Input() action: string = ''; // Para ocultar en comentarios

  @Output() tabChange = new EventEmitter<string>();
  @Output() mapClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  private tabsConfig: Record<number, TabButton[]> = {
    1: [ // Hoteles
      { id: 'product', label: 'HABITACIÓN', showOnQuote: true },
      { id: 'info', label: 'INFO' },
      { id: 'maps', label: 'MAPA', action: 'map' },
      { id: 'photos', label: 'FOTOS' },
      { id: 'comments', label: 'COMENTARIOS' }
    ],
    2: [ // Rent a Car
      { id: 'product', label: 'PLAN', showOnQuote: true },
      { id: 'OPCIONALES', label: 'REGLAS DE TARIFA' },
      { id: 'INFO', label: 'INFO' },
      { id: 'comments', label: 'COMENTARIOS' }
    ],
    6: [ // Tours / Experiences
      { id: 'product', label: 'TOUR', showOnQuote: true },
      { id: 'maps', label: 'MAPA', action: 'map' },
      { id: 'photos', label: 'FOTOS' },
      { id: 'info', label: '+ INFO' },
      { id: 'comments', label: 'COMENTARIOS' }
    ],
    8: [ // Transfers
      { id: 'product', label: 'SELECCIÓN', showOnQuote: true },
      { id: 'info', label: 'INFO', disabledByProduct: true },
      { id: 'comments', label: 'COMENTARIOS', disabledByProduct: true }
    ],
    9: [ // Tickets (mismo que tours)
      { id: 'product', label: 'TICKET', showOnQuote: true },
      { id: 'maps', label: 'MAPA', action: 'map' },
      { id: 'photos', label: 'FOTOS' },
      { id: 'info', label: '+ INFO' },
      { id: 'comments', label: 'COMENTARIOS' }
    ]
  };

    get tabs(): TabButton[] {
    const config = this.tabsConfig[this.categoryId] || this.tabsConfig[1];

    // Filtrar tabs según condiciones
    return config.filter(tab => {
      // Ocultar si action === 'comments'
      if (this.action === 'comments') return false;

      // Ocultar tabs que requieren quote
      if (tab.showOnQuote && !this.quote) return false;

      return true;
    }).map(tab => ({
      ...tab,
      disabled: this.isTabDisabled(tab)
    }));
  }

  private isTabDisabled(tab: TabButton): boolean {
    // Tabs que se deshabilitan si no hay producto seleccionado
    if ((tab.disabledByProduct || tab.id === 'info' || tab.id === 'comments') && !this.productSelect) {
      return true;
    }
    return false;
  }

  onTabClick(tab: TabButton): void {
    if (tab.disabled) return;

    if (tab.action === 'map') {
      this.mapClick.emit();
    }

    this.tabChange.emit(tab.id);
  }

}
